/** @format */

import template from './gb-raffle-widget-item-name.html';
import './gb-raffle-widget-item-name.scss';

export const GbRaffleWidgetItemNameComponent = {
    template,
    bindings: {
        raffleItemId: '<',
    },
    controller: class GbRaffleWidgetItemNameComponent {
        constructor($gbItem, $gbRaffleItem) {
            'ngInject';

            this.$gbItem = $gbItem;
            this.$gbRaffleItem = $gbRaffleItem;
        }

        getItemByRaffleItemId() {
            let raffleItem = this.$gbRaffleItem.cache.single(this.raffleItemId);

            if (raffleItem) {
                return this.$gbItem.cache.single(raffleItem.item);
            }
        }
    },
};
